import {
  INSIGHT_HINT_TITLE,
  insightAxisPresentations,
} from '@/components/insights/insight-display';
import type { InsightSavedHintContext } from '@/types/insights';
import { formatDate } from '@/utils/formatters';
import { STATES, type SwrState } from '@/utils/swr';

export type SavedInsightHeader = {
  dateLabel: string;
  axisLabel: string;
  title: string;
};

export const toSavedInsightHeader = (
  context: InsightSavedHintContext,
): SavedInsightHeader => ({
  dateLabel: formatDate(context.insight_date),
  axisLabel: insightAxisPresentations[context.axis].label,
  title: INSIGHT_HINT_TITLE,
});

const isListPending = (state: SwrState) =>
  state === 'idle' || state === STATES.PENDING;

export type SavedInsightsTabView = 'loading' | 'failed' | 'empty' | 'list';

export const resolveSavedInsightsTabView = (
  state: SwrState,
  count: number,
): SavedInsightsTabView => {
  if (isListPending(state)) return 'loading';
  if (state === STATES.ERROR) return 'failed';
  return count === 0 ? 'empty' : 'list';
};
